var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculateRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.745605 19.3333H8.56703V16.6667H0.745605V19.3333ZM21.6027 0.666668H0.745605V3.33333H21.6027V0.666668ZM17.692 8.66667H0.745605V11.3333H18.0179C19.4519 11.3333 20.6251 12.5333 20.6251 14C20.6251 15.4667 19.4519 16.6667 18.0179 16.6667H15.0849V14L11.1742 18L15.0849 22V19.3333H17.692C20.5729 19.3333 22.9063 16.9467 22.9063 14C22.9063 11.0533 20.5729 8.66667 17.692 8.66667Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculateRoute);
export default __webpack_public_path__ + "static/media/calculate_route.8fd9f2f76d195bebca1f4ffa5f17f929.svg";
export { ForwardRef as ReactComponent };